// Modules
import React, { Component } from 'react';
import PropTypes from 'prop-types';
// Components
import OMTwinInputRow from '../OMComponents/OMTwinInputRow/OMTwinInputRow';
import OMCheckbox from '../OMComponents/OMCheckbox/OMCheckbox';
import OMAdvancedFiltersCheckbox from '../OMComponents/OMAdvancedFiltersCheckbox/OMAdvancedFiltersCheckbox';
import OMFiltersTitle from '../OMComponents/OMFiltersTitle/OMFiltersTitle';
import MinMaxPrices from '../MinMaxPrices/MinMaxPrices';

// Helpers
import beautifyNumber from '../../helpers/beautifyNumber';
import clearNumber from '../../helpers/clearNumber';
import * as styles from './QuantitativeFilters.scss';

class QuantitativeFilters extends Component {
  handleChange = (evt, field, fieldValue) => {
    const value = evt.currentTarget.value.replace(/[\D]/g, '');
    evt.currentTarget.value = value;

    const { floor, area, constructionYear } = this.props.fields;
    if (field === 'floor') {
      if (value > 99) {
        return;
      }
      if (fieldValue === 'min' && +floor.max > 0 && +floor.max < +value) {
        return;
      }
      this.props.onChange('floor', { ...floor, [fieldValue]: value });
    }

    if (field === 'area') {
      if (value > 9999) {
        return;
      }
      if (fieldValue === 'min' && +area.max > 0 && +area.max < +value) {
        return;
      }
      this.props.onChange('area', { ...area, [fieldValue]: value });
    }

    if (field === 'constructionYear') {
      if (fieldValue === 'min' && +constructionYear.max > 0 && +constructionYear.max < +value) {
        return;
      }
      if (value.length >= 4 && (value < 1900 || value > 2027)) {
        this.props.onChange('constructionYear', { ...constructionYear, [fieldValue]: null });
      } else {
        this.props.onChange('constructionYear', { ...constructionYear, [fieldValue]: value });
      }
    }
  };

  formatPriceParameters = field => ({
    value: beautifyNumber(this.props.fields.price[field]),
    onChange: value => this.props.onChange('price', {
      ...this.props.fields.price,
      [field]: clearNumber(value)
    })
  });

  createParams = (field, fieldValue) => {
    const value = this.props.fields[field][fieldValue];
    return {
      value: value || '',
      onChange: evt => this.handleChange(evt, field, fieldValue)
    };
  };

  renderPrice = () => (
    <div className={styles.priceField}>
      <OMFiltersTitle
        icon="coin"
        label={this.props.translate('search_box', 'searchContainer', 'price')}
      />
      <div className={styles.priceWrapper}>
        <MinMaxPrices
          inFilters
          className="lineFiltersPrice"
          translate={this.props.translate}
          minPrice={this.formatPriceParameters('minPrice')}
          maxPrice={this.formatPriceParameters('maxPrice')}
          minPlaceholder={`${this.props.translate('advancedFilters', 'minPlaceholder')}`}
          maxPlaceholder={`${this.props.translate('advancedFilters', 'maxPlaceholder')}`}
          separator={this.props.translate('advancedFilters', 'until').toString()}
        />
        <span>₪</span>
      </div>
    </div>);

  render() {
  const smallScreen =
    typeof window !== 'undefined' ? window.innerWidth < 1180 : false;
    const { notLastFloor } = this.props.fields;
    const filtersCheckboxesArray = ['parkingSpot', 'balcony', 'elevator'];
    const { isMobile } = this.props;

    return (
      <div className={styles.wrapper}>
        {filtersCheckboxesArray.map(field =>
          (<OMAdvancedFiltersCheckbox
            key={field}
            name={field}
            label={`${this.props.translate('advancedFilters', field)}`}
            value={this.props.fields[field]}
            isMobile={isMobile}
            onChange={this.props.onChange}
          />)
        )}
        <div className={styles.floorWrapper}>
          <OMTwinInputRow
            field={{
              min: this.createParams('floor', 'min'),
              max: this.createParams('floor', 'max')
            }}
            checkMaxValue={() => this.props.handleCheckMaxValue('floor')}
            label={`${this.props.translate('advancedFilters', 'floor')}`}
            icon="floor"
            minPlaceholder={`${this.props.translate('advancedFilters', 'floor')}`}
            maxPlaceholder={`${this.props.translate('advancedFilters', 'floor')}`}
            isMobile={isMobile}
            className="advancedFiltersTwin"
            separator={this.props.translate('advancedFilters', 'until').toString()}
          />
          <OMCheckbox
            field={{
              value: notLastFloor,
              checked: notLastFloor,
              onChange: () => this.props.onChange('notLastFloor', !notLastFloor)
            }}
            label={`${this.props.translate('advancedFilters', 'notLastFloor')}`}
          />
        </div>
        {smallScreen && !isMobile && this.renderPrice()}
        <div className={styles.sizeWrapper}>
          <OMTwinInputRow
            field={{
              min: this.createParams('area', 'min'),
              max: this.createParams('area', 'max')
            }}
            checkMaxValue={() => this.props.handleCheckMaxValue('area')}
            label={`${this.props.translate('advancedFilters', 'size')}`}
            icon="square"
            minPlaceholder={`${this.props.translate('advancedFilters', 'minPlaceholder')}`}
            maxPlaceholder={`${this.props.translate('advancedFilters', 'maxPlaceholder')}`}
            isMobile={isMobile}
            className="advancedFiltersTwin"
            separator={this.props.translate('advancedFilters', 'until').toString()}
          />
        </div>
        <div className={styles.yearWrapper}>
          <OMTwinInputRow
            field={{
              min: this.createParams('constructionYear', 'min'),
              max: this.createParams('constructionYear', 'max')
            }}
            checkMaxValue={() => this.props.handleCheckMaxValue('constructionYear')}
            label={`${this.props.translate('advancedFilters', 'constructionYear')}`}
            icon="construction-year"
            minPlaceholder={`${this.props.translate('advancedFilters', 'yearMinPlaceholder')}`}
            maxPlaceholder={`${this.props.translate('advancedFilters', 'yearMaxPlaceholder')}`}
            isMobile={isMobile}
            className="advancedFiltersTwin"
            separator={this.props.translate('advancedFilters', 'until').toString()}
          />
        </div>

      </div>
    );
  }
}

QuantitativeFilters.propTypes = {
  translate: PropTypes.func,
  fields: PropTypes.object,
  isMobile: PropTypes.bool,
  onChange: PropTypes.func,
  handleCheckMaxValue: PropTypes.func
};

export default QuantitativeFilters;
